import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { Toggle } from '../ui/toggle';

function SortButton({ sortDescending, onToggle }) {
  return (
    <Toggle
      pressed={!sortDescending}
      onPressedChange={onToggle}
      size="sm"
      className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground [@media(hover:hover)_and_(pointer:fine)]:hover:shadow-md"
      aria-label={sortDescending ? "Sort ascending" : "Sort descending"}
    >
      {sortDescending ? <ArrowDown className="h-4 w-4" /> : <ArrowUp className="h-4 w-4" />}
    </Toggle>
  );
}

export default SortButton;
